import { importAll, transformImages } from "utils";

import Gallery from "components/Media/Gallery";
import { Link } from "react-router-dom";
import ReplicaContent from "components/Replicas/ReplicaContent";
import ReplicaParagraph from "components/Replicas/ReplicaParagraph";
import ReplicaSpacer from "components/Replicas/ReplicaSpacer";
import backgroundImage from "./gallery/promo_02.jpg";
import beedleTheBard from "assets/replicas/harry-potter/hp-tales-of-beedle-the-bard";
import beedleTheBardV1 from "assets/replicas/harry-potter/hp-tales-of-beedle-the-bard/v1";
import { routes } from "config";

let gallery = [];
let gallery2 = [];
try {
  gallery = importAll(
    (require as any).context("./gallery", false, /\.(png|jpe?g|svg)$/),
  );
  gallery2 = importAll(
    (require as any).context("./gallery-2", false, /\.(png|jpe?g|svg)$/),
  );
} catch (e) {
  console.warn(e);
}

const background = {
  src: backgroundImage,
  opacity: 0.1,
};

const Page = () => {
  const galleryImages = transformImages(gallery);
  const galleryImages2 = transformImages(gallery2);

  return (
    <ReplicaContent>
      <ReplicaParagraph>
        This is a Grade-B level complete fully readable replica of{" "}
        <Link
          to={`/${routes.replicaDetailVersion.slug.replace(":id", beedleTheBard.id).replace(":version", `v${beedleTheBardV1.version}`)}`}
          target="_blank"
        >
          The Tales of Beedle the Bard v1
        </Link>
        . The only blemishes are the endpapers — they slightly differ in color,
        have a bit of damage, and the golden outline is missing, as this book
        was created at an earlier stage of the replica's development. That being
        said, the rest of the book is 1:1 with the final v1 replica, from the
        outside and the inside.
      </ReplicaParagraph>

      <ReplicaSpacer />
      <Gallery
        images={galleryImages}
        imagesPerRow={4}
        aspectRatio={1}
        imageMaxHeight="200px"
        imageOptions={[{ index: 2, aspectRatio: 2 }]}
      />
      <ReplicaSpacer />

      <ReplicaParagraph>
        The good thing about this replica is that, since it's supposed to be a
        very old book, some heavy damage is to be expected. This Grade-B can, I
        think, be cherished just like the Grade-A replicas, especially given the
        book's intended aged appearance.
      </ReplicaParagraph>

      <ReplicaSpacer />
      <Gallery
        images={galleryImages2}
        imagesPerRow={4}
        aspectRatio={1}
        imageMaxHeight="400px"
        imageOptions={[{ index: 0, aspectRatio: 2 }]}
      />
      <ReplicaSpacer />
    </ReplicaContent>
  );
};

export default Page;
export { background };
